<template>
  <div ref="char" class="char"></div>
</template>

<script>
import * as echarts from 'echarts';
import china from '../../lib/china.json';
echarts.registerMap('china', china);
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Map1",
  data() {
    return {
      resultdata0: [],
      yMax: 1000,
      dataShadow: [],
      option: {}
    };
  },
  methods: {
  },
  created() {
    let user_id = window.localStorage.getItem('user_id');

    const data = {
      'user_id': user_id
    };

    this.$api.zq_map1(data).then(res=>
    {
      // console.log(res);
      this.option = {
        title: [
          {
            show: false,
            text: '地域分布'
          },
          {
            show: false,
            text: '省份/直辖市TOP6',
            right: '20',
            textStyle: {
              color: '#666666',
              fontSize: 12
            }
          }
        ],

        //鼠标移入弹窗
        tooltip: {
          trigger: 'item',
          textStyle:{
            fontSize:14,
            color:'#fff'
          },
          // backgroundColor: 'rgba(51, 51, 51, 0.7)',
          backgroundColor: '#234EA5',
          // borderColor: 'rgba(51, 51, 51, 0.7)',
          borderWidth:0,
          formatter: function (val) {
            // console.log(val)
            let res=`<div>
                        <div style="text-align: left"> ${val.data.name}</div>
                        <div style="text-align: left">总消费金额 : ${val.data.value}</div>
                        <div style="text-align: left">消费帮扶总额 : ${val.data.value1}</div>
                    </div>`
            return res
          }

        },

        //调整色块阴暗度
        visualMap: {
          type: 'continuous',
          min: 0,
          max: 1000,
          show:false,
          text: ['高', '低'],
          seriesIndex: [0, 2],
          dimension: 0,
          realtime: false,
          right: '5%',
          bottom: '5',
          orient: 'vertical',
          textBorderColor: '#fff',
          itemWidth: 10,
          itemHeight: 120,
          calculable: false,
          inRange: {
            color: [ '#6e94ef','#162858'],
            symbolSize: [100, 100]
          },
          outOfRange: {
            color: ['#eeeeee'],
            symbolSize: [100, 100]
          },
          textStyle: {}
        },
        toolbox: {
          show: false
        },

        //x轴
        xAxis: [
          {
            type: 'value',
            position: 'top',
            inside: false,
            axisLabel: {
              show: false
            },
            splitLine: {
              show: false
            },
            margin: 10
          }
        ],

        //y轴
        yAxis: [
          {
            type: 'category',
            boundaryGap: false,
            axisLine: {
              show: false
            },
            axisLabel: {
              align: 'right',
              color: '#000',
              margin: 10,
              showMaxLabel: true
            },
            axisTick: {
              show: false
            },
          }
        ],

        series: [
          {
            name: '',
            type: 'map',
            mapType: 'china',
            left: '15%',
            width: '70%',
            roam: true,
            mapValueCalculation: 'sum',
            zoom: 1.3,
            selectedMode: false,
            showLegendSymbol: false,
            //地图显示字符颜色
            label: {
              normal: {
                textStyle: {
                  color: '#DBF8FF',
                  fontSize: 12
                },
                show: true
              },
              emphasis: {
                textStyle: {
                  color: '#234EA5'
                }
              }
            },
            //鼠标移入背景色
            itemStyle: {
              normal: {
                areaColor: '#134f71',
                borderColor: '#134f71'
              },
              emphasis: {
                areaColor: '#E5F39B'
              }
            },
            data: res
          },
        ]
      }
      this.myChart = echarts.init(this.$refs.char);
      this.myChart.setOption(this.option);

    })
    // this.init2();
  },
};
</script>

<style lang="less" scoped>
.char {
  width: 100%;
  height: 100%;
}
</style>